import React from 'react';

import { Row, Form } from 'react-bootstrap';

import './styles.scoped.css';

// PRST-134 criteria card. Worker Number OR Worker SSN identifies the worker (exactly one), and the
// Period Requested date range is always required — hence three red asterisks but only two of them
// satisfiable at once. The OR / AND captions between the rows come straight from the ticket.
// PRST-139: no placeholder descriptors on the identifier inputs, and the label column is one
// shared class (.criteria-label) wide enough for "Period Requested Dates *" so the three inputs
// share a left edge instead of the longest label shoving its date field over. The class sits on
// the inner <div>, not on Form.Label: styles.scoped.css only matches elements the scoped-css
// babel plugin stamps with data-v-…, and it stamps plain DOM JSX, never a react-bootstrap
// component's rendered <label>. The label itself just needs Bootstrap's mb-0.
export const PayrollVerificationForm = ({ form, handleChange, errors }) => (
  <div className="filters-container">
    <div className="filter-row" style={{ marginTop: '30px' }}>
      <Form.Group as={Row} controlId="EmployeeId" style={{ alignItems: 'center' }}>
        <Form.Label className="mb-0">
          <div className="required criteria-label">Worker Number</div>
        </Form.Label>
        <Form.Control
          style={{ width: '250px', height: '30px' }}
          as="input"
          type="text"
          inputMode="numeric"
          name="EmployeeId"
          value={form?.EmployeeId}
          onChange={handleChange}
        />
      </Form.Group>
    </div>
    {errors?.WorkerIdentity && <div className="field-error">{errors.WorkerIdentity}</div>}
    {errors?.EmployeeId && <div className="field-error">{errors.EmployeeId}</div>}

    <div className="filter-row conjunction">OR</div>

    <div className="filter-row">
      <Form.Group as={Row} controlId="SSNO" style={{ alignItems: 'center' }}>
        <Form.Label className="mb-0">
          <div className="required criteria-label">Worker SSN</div>
        </Form.Label>
        <Form.Control
          style={{ width: '250px', height: '30px' }}
          as="input"
          type="text"
          name="SSNO"
          autoComplete="off"
          value={form?.SSNO}
          onChange={handleChange}
        />
      </Form.Group>
    </div>
    {errors?.SSNO && <div className="field-error">{errors.SSNO}</div>}

    <div className="filter-row conjunction">AND</div>

    <div className="filter-row">
      <Form.Group as={Row} style={{ alignItems: 'center' }}>
        <Form.Label className="mb-0">
          <div className="required criteria-label">Period Requested Dates</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="FromPerEnddate"
          aria-label="From Period End Date"
          value={form?.FromPerEnddate}
          onChange={handleChange}
          max={form?.ToPerEnddate || undefined}
        />
        <span className="date-divider">to</span>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="ToPerEnddate"
          aria-label="To Period End Date"
          value={form?.ToPerEnddate}
          onChange={handleChange}
          min={form?.FromPerEnddate || undefined}
        />
      </Form.Group>
    </div>
    {errors?.PeriodRequestedDates && <div className="field-error">{errors.PeriodRequestedDates}</div>}
  </div>
);

export default PayrollVerificationForm;
